<template>
  <div class="home-container">
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {

    
  },
}
</script>
